<template>
  <div id="app">
    <ErrorView
      v-if="!online"
      style="height: 100vh"
      message="Your connection is offline"
    />
    <template v-else>
      <state-change-overlay />
      <propose-challenge-change-overlay />

      <router-view />
    </template>
  </div>
</template>

<script>
import StateChangeOverlay from './views/StateChangeOverlay.vue'
import ProposeChallengeChangeOverlay from './views/ProposeChallengeChangeOverlay.vue'
import ErrorView from '@/components/ErrorView.vue'

export default {
  components: { StateChangeOverlay, ProposeChallengeChangeOverlay, ErrorView },
  name: 'App',
  data() {
    return {
      online: navigator.onLine
    }
  },
  mounted() {
    window.addEventListener('online', this.onOnlineChange)
    window.addEventListener('offline', this.onOnlineChange)
    this.onOnlineChange()
  },
  beforeDestroy() {
    window.removeEventListener('online', this.onOnlineChange)
    window.removeEventListener('offline', this.onOnlineChange)
  },
  methods: {
    onOnlineChange() {
      this.online = navigator.onLine
    }
  }
}
</script>
